module.exports = __webpack_public_path__ + "static/media/flashInfoBlue.dc45bb7f.svg";